import { jsx as _jsx } from "react/jsx-runtime";
import { useDispatch } from 'react-redux';
import { EndpointKey } from '../http/EndpointKey';
import { retryEndpoint } from '../store/http-responses/action-creators';
import { ErrorKey } from './ErrorKey';
import StandardError from './StandardError';

const StandardCreationError = () => {
  const dispatch = useDispatch();
  const errorKey = ErrorKey.StandardCreationError;

  const onClick = event => {
    event.preventDefault(); // Adding a timeout for better chances of success in case of server unreliability

    dispatch(retryEndpoint(EndpointKey.Signup, 2200));
  };

  return /*#__PURE__*/_jsx(StandardError, {
    errorKey: errorKey,
    onSentenceWithLinkClick: onClick
  });
};

export default StandardCreationError;